// extracted by mini-css-extract-plugin
export default {"root":"IYb62E4F"};